module.exports = __webpack_public_path__ + "static/img/4-01.c2debeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4-01.png
// module id = 177
// module chunks = 1